var styleDataHash = "1caf67c9";
const injectCss = (() => {
  var css = `.M8Wbh{flex-direction:row;gap:18px;height:162px}.M8Wbh,.oEKh9{align-items:center;display:flex}.oEKh9{flex-direction:column;gap:8px}.zsKR5{max-height:162px;width:162px}.p-bU8{display:flex;flex-direction:column;flex-wrap:wrap;gap:1rem;padding-inline:1rem}.zsKR5[data-animated=true]{mask:linear-gradient(180deg,transparent,#fff 20%,#fff 80%,transparent);-webkit-mask:linear-gradient(180deg,transparent,#fff 20%,#fff 80%,transparent);overflow:hidden}.zsKR5[data-animated=true] .p-bU8{animation:l7Sfm 5s linear infinite;flex-wrap:nowrap;height:max-content}@keyframes l7Sfm{to{transform:translateY(calc(-50% - .5rem))}}.g9cm2{color:#116dff;opacity:0;position:absolute}.g9cm2._2yDFB{animation:_0uHsW 1.5s ease-in-out forwards}@keyframes _0uHsW{0%{opacity:1;transform:rotate(-1turn)}10%{opacity:1;transform:rotate(0deg)}75%{opacity:1;transform:rotate(0deg)}85%{opacity:1;transform:rotate(-45deg)}to{opacity:.5;transform:rotate(45deg)}}.tLyMF{background:linear-gradient(180deg,#e7f0ff 0,#a8caff 70%);border-radius:1px;height:124px;width:2px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var loader_default = {
  "root": "M8Wbh",
  "leftSide": "oEKh9",
  "scroller": "zsKR5",
  "scrollerInner": "p-bU8",
  "scroll": "l7Sfm",
  "icon": "g9cm2",
  "visible": "_2yDFB",
  "lifecycle": "_0uHsW",
  "line": "tLyMF"
};
export {
  loader_default as default,
  injectCss
};
//# sourceMappingURL=loader-scss.js.map
